import { routes } from "modules/common/routes";
import { OrderTabs } from "modules/orders-manage/details/OrderDetailsTabsPage";
import orderFunc from "modules/orders-manage/functionalities";
import { PARAM_RECORD } from "modules/orders-manage/models/order";
import { canAny } from "modules/session/auth/access";
import spendingFunc from "modules/spending/functionalities";

/**
 * Адреса переходов из графиков. Без прав на целевую карточку — null: подпись остаётся
 * текстом, а не ссылкой, которая всё равно откроет пустую страницу.
 */
export interface PlanLinks {
    /** Карточка проекта, «Основные данные» */
    order: (orderId: string) => string | null;
    /** «Состав проекта» с прокруткой к разделу и его подсветкой */
    section: (orderId: string, sectionId: string | null | undefined) => string | null;
    /** Карточка сотрудника */
    employee: (employerId: string | null | undefined) => string | null;
}

export function buildPlanLinks(access: string[]): PlanLinks {
    const canOrder = canAny([orderFunc.ORDERS_SUMMARY_EDIT, orderFunc.ORDERS_SUMMARY_READ], access);
    const canContent = canAny([orderFunc.ORDERS_CONTENTS_EDIT, orderFunc.ORDERS_CONTENTS_READ], access);
    const canEmployee = canAny([spendingFunc.EMPLOYER_READ], access);

    return {
        order: (orderId) => (canOrder && orderId ? routes.orders.details(orderId, OrderTabs.summary) : null),
        section: (orderId, sectionId) =>
            canContent && orderId && sectionId
                ? // раскрыть стадию раздела вкладка «Состав проекта» сумеет сама — по guid
                  `${routes.orders.details(orderId, OrderTabs.content)}&${PARAM_RECORD}=${sectionId}`
                : null,
        employee: (employerId) => (canEmployee && employerId ? routes.spending.employee.details(employerId) : null),
    };
}
